import React from 'react';

const TransportadorInternacionalContext = React.createContext();

export default TransportadorInternacionalContext;
